<template>
  <div class="hello">
    <nav class="navbar has-shadow" role="navigation" aria-label="main navigation">
      <div class="container">
        <div class="navbar-brand">
          <a class="navbar-item" href="/">
          <img src="http://oi64.tinypic.com/nfpimd.jpg" alt="Richard Gamora" >
          </a>
          <div class="navbar-burger"  data-target="navbar-menu">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
        <div class="navbar-menu" id="navbar-menu">
          <div class="navbar-start">
            <div class="navbar-end">
              <router-link to="/" class="navbar-item">HOME</router-link>
              <router-link to="/about" class="navbar-item">ABOUT ME</router-link>
              <router-link to="/projects" class="navbar-item">PROJECTS</router-link>
            </div>
          </div>
        </div>
      </div>
    </nav>
  </div>
</template>
<script>
export default {
  mounted () {
    // Get all "navbar-burger" elements
    var $navbarBurgers = Array.prototype.slice.call(document.querySelectorAll('.navbar-burger'), 0);

    // Check if there are any navbar burgers
    if ($navbarBurgers.length > 0) {

      // Add a click event on each of them
      $navbarBurgers.forEach(function ($el) {
        $el.addEventListener('click', function () {

          // Get the target from the "data-target" attribute
          var target = $el.dataset.target;
          var $target = document.getElementById(target);

          // Toggle the class on both the "navbar-burger" and the "navbar-menu"
          $el.classList.toggle('is-active');
          $target.classList.toggle('is-active');

        });
      });
    }
  }
}
</script>